import React from 'react'
import { Link } from 'react-router-dom'
import TutorSidebar from '../../../../TutorSidebar/TutorSidebar'

const TutorAddSubjectiveMockAssessment = () => {
    return (
        <div>

            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <Link to="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </Link>
                            &nbsp;&nbsp;My Assessments
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <TutorSidebar />
                        </div>
                        <div className="col-lg-9">
                            <main className="px-3 py-4">
                                <div className="study-material">
                                    <div className="row study-material-card-sec">
                                        <div className="col-lg-4 col-md-6 mb-3">
                                            {/* Add Objective Test card */}
                                            <div className="card" id="add-study-tab">
                                                <Link to="/tutor/add-mock-objective-assessment">
                                                    <div className="card-body">
                                                        <div className="row">
                                                            <div className="col-lg-3 col-md-3 col-3">
                                                                <div className="icon-sec">
                                                                    <i className="bi bi-file-earmark-richtext" />
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-9 col-md-9 col-9">
                                                                <h5 className="mb-0">Add Objective Test</h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </div>
                                        </div>
                                        {/* Add Subjective Test card */}
                                        <div className="col-lg-4 col-md-6 mb-3">
                                            <div className="card" id="view-study-tab">
                                                <div className="card-body">
                                                    <div className="row">
                                                        <div className="col-lg-3 col-md-3 col-3">
                                                            <div className="icon-sec">
                                                                <i className="bi bi-file-earmark-richtext" />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-9 col-md-9 col-9">
                                                            <h5 className="mb-0">Add Subjective Test</h5>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Add Subjective Test Start section */}
                                    <div
                                        className="view-study-material-sec mt-5"
                                        id="view-study-tab-pane"

                                    >
                                        <ul className="nav nav-tabs my-student-nav-sec" id="myTab" role="tablist">
                                            <li className="nav-item" role="presentation">
                                                <button
                                                    className="nav-link active"
                                                    id="sub-one-to-one-tab"
                                                    data-bs-toggle="tab"
                                                    data-bs-target="#sub-one-to-one"
                                                    type="button"
                                                    role="tab"
                                                    aria-controls="home"
                                                    aria-selected="true"
                                                >
                                                    One To One
                                                </button>
                                            </li>
                                            <li className="nav-item" role="presentation">
                                                <button
                                                    className="nav-link"
                                                    id="sub-group-tab"
                                                    data-bs-toggle="tab"
                                                    data-bs-target="#sub-group"
                                                    type="button"
                                                    role="tab"
                                                    aria-controls="profile"
                                                    aria-selected="false"
                                                >
                                                    Group Tutoring
                                                </button>
                                            </li>
                                        </ul>
                                        <div className="tab-content my-student-tab-pane" id="myTabContent">
                                            <div
                                                className="tab-pane fade show active"
                                                id="sub-one-to-one"
                                                role="tabpanel"
                                                aria-labelledby="sub-one-to-one-tab"
                                            >
                                                <div className="row my-4">
                                                    <div className="col-lg-4 col-md-6">
                                                        <label htmlFor="" className="label">
                                                            Select Course
                                                        </label>
                                                        <br />
                                                        <select className="select-form w-100 rounded">
                                                            <option value="">-Select-</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-lg-4 col-md-6">
                                                        <label htmlFor="" className="label">
                                                            Assessment name
                                                        </label>
                                                        <br />
                                                        <input
                                                            type="text"
                                                            className="input-card-form w-100 rounded"
                                                            placeholder="Enter assessment name"
                                                        />
                                                    </div>
                                                    <div className="col-lg-4 col-md-6">
                                                        <label htmlFor="" className="label">
                                                            No. of Questions
                                                        </label>
                                                        <br />
                                                        <input
                                                            type="text"
                                                            className="input-card-form w-100 rounded"
                                                            placeholder={0}
                                                        />
                                                    </div>
                                                    <div className="col-lg-4 col-md-6">
                                                        <label htmlFor="" className="label">
                                                            Total Marks
                                                        </label>
                                                        <br />
                                                        <input
                                                            type="text"
                                                            className="input-card-form w-100 rounded"
                                                            placeholder="Total Marks"
                                                        />
                                                    </div>
                                                    <div className="col-lg-4 col-md-6">
                                                        <label htmlFor="" className="label">
                                                            Duration(In Min)
                                                        </label>
                                                        <br />
                                                        <input
                                                            type="text"
                                                            className="input-card-form w-100 rounded"
                                                            placeholder="Duration"
                                                        />
                                                    </div>
                                                    <div className="col-lg-4 col-md-6">
                                                        <label htmlFor="" className="label">
                                                            Start Date
                                                        </label>
                                                        <br />
                                                        <input
                                                            type="date"
                                                            className="input-card-form w-100 rounded"
                                                            placeholder="Enter material name"
                                                        />
                                                    </div>
                                                    <div className="col-lg-4 col-md-6">
                                                        <label htmlFor="" className="label">
                                                            End Date
                                                        </label>
                                                        <br />
                                                        <input
                                                            type="date"
                                                            className="input-card-form w-100 rounded"
                                                            placeholder="Enter material name"
                                                        />
                                                    </div>
                                                    <div className="col-lg-2">
                                                        <Link to="/tutor/add-mock-subjective-questions">
                                                            <input
                                                                type="submit"
                                                                defaultValue="Next"
                                                                className="btn btn-primary srch-btn w-100"
                                                            />
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                className="tab-pane fade"
                                                id="sub-group"
                                                role="tabpanel"
                                                aria-labelledby="sub-group-tab"
                                            >
                                                <div className="row my-4">
                                                    <div className="col-lg-4 col-md-6">
                                                        <label htmlFor="" className="label">
                                                            Select Course
                                                        </label>
                                                        <br />
                                                        <select className="select-form w-100 rounded">
                                                            <option value="">-Select-</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-lg-4 col-md-6">
                                                        <label htmlFor="" className="label">
                                                            Select Batch
                                                        </label>
                                                        <br />
                                                        <select className="select-form w-100 rounded">
                                                            <option value="">-Select-</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-lg-4 col-md-6">
                                                        <label htmlFor="" className="label">
                                                            Assessment name
                                                        </label>
                                                        <br />
                                                        <input
                                                            type="text"
                                                            className="input-card-form w-100 rounded"
                                                            placeholder="Enter assessment name"
                                                        />
                                                    </div>
                                                    <div className="col-lg-4 col-md-6">
                                                        <label htmlFor="" className="label">
                                                            No. of Questions
                                                        </label>
                                                        <br />
                                                        <input
                                                            type="text"
                                                            className="input-card-form w-100 rounded"
                                                            placeholder={0}
                                                        />
                                                    </div>
                                                    <div className="col-lg-4 col-md-6">
                                                        <label htmlFor="" className="label">
                                                            Total Marks
                                                        </label>
                                                        <br />
                                                        <input
                                                            type="text"
                                                            className="input-card-form w-100 rounded"
                                                            placeholder="Total Marks"
                                                        />
                                                    </div>
                                                    <div className="col-lg-4 col-md-6">
                                                        <label htmlFor="" className="label">
                                                            Duration(In Min)
                                                        </label>
                                                        <br />
                                                        <input
                                                            type="text"
                                                            className="input-card-form w-100 rounded"
                                                            placeholder="Duration"
                                                        />
                                                    </div>
                                                    <div className="col-lg-4 col-md-6">
                                                        <label htmlFor="" className="label">
                                                            Start Date
                                                        </label>
                                                        <br />
                                                        <input
                                                            type="date"
                                                            className="input-card-form w-100 rounded"
                                                            placeholder="Enter material name"
                                                        />
                                                    </div>
                                                    <div className="col-lg-4 col-md-6">
                                                        <label htmlFor="" className="label">
                                                            End Date
                                                        </label>
                                                        <br />
                                                        <input
                                                            type="date"
                                                            className="input-card-form w-100 rounded"
                                                            placeholder="Enter material name"
                                                        />
                                                    </div>
                                                    <div className="col-lg-2">
                                                        <Link to="/tutor/add-mock-subjective-questions">
                                                            <input
                                                                type="submit"
                                                                defaultValue="Next"
                                                                className="btn btn-primary srch-btn w-100"
                                                            />
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* Add Subjective Test End section */}
                                </div>
                            </main>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    )
}

export default TutorAddSubjectiveMockAssessment